import type { FaireProductEntity } from "../../entity_types/product";

export const p_8drwd5g4pa: FaireProductEntity = {
  token: "p_8drwd5g4pa",
  type: "product",
  name: "Salty Beach Cold Process Soap",
  brandName: "Soap de Jolie",
  imageUrl:
    "https://cdn.faire.com/fastly/82e7c3375f11eca3c02e27071affebdef55baca7985ad6a5e9da4515a60487e0.jpeg",
  priceDollars: 4.15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2694c430597e35d942feb11136bc7d3972c6fbe9f2d816f697358b8c3ac35fb8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
